// Auto-generated from digital-asset-week.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals ---------- */
  var items = document.querySelectorAll('.up, .line, .cmp');
  if (reduce || !('IntersectionObserver' in window)){
    Array.prototype.forEach.call(items, function(el){ el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, {rootMargin:'0px 0px -6% 0px', threshold:0.08});
    Array.prototype.forEach.call(items, function(el){ io.observe(el); });
  }

  /* ---------- the card deck: a drag carousel ---------- */
  var fan   = document.getElementById('fan');
  var surf  = document.getElementById('fan-drag');
  var cards = Array.prototype.slice.call(fan.querySelectorAll('.fan-card'));
  var hint  = document.getElementById('fan-hint');
  var N = cards.length;

  var progress = 0, target = 0, vel = 0, raf = null;

  function cfg(){
    var w = window.innerWidth;
    if (w < 640)  return {x:114, y:5,  rot:2.5, sc:.035, sens:170, dist:120, velDiv:520};
    if (w < 1024) return {x:170, y:7,  rot:3,   sc:.045, sens:210, dist:160, velDiv:650};
    return              {x:224, y:9,  rot:3.5, sc:.055, sens:250, dist:200, velDiv:800};
  }
  function wrap(d){ if (d >  N/2) d -= N; if (d < -N/2) d += N; return d; }
  function offsetOf(i){ return wrap(((i - progress) % N + N) % N); }

  function drawDeck(){
    var c = cfg();
    for (var i = 0; i < N; i++){
      var d = offsetOf(i), a = Math.abs(d);
      var rot = a < .05 ? 0 : d * c.rot;
      var edge = N/2 - 0.5;
      var op = a > edge ? Math.max(0, (N/2 - a) / 0.5) : 1;
      var el = cards[i];
      el.style.transform = 'translate(-50%,-50%) translate(' + (d*c.x) + 'px,' + (a*c.y) + 'px)'
                         + ' rotate(' + rot + 'deg) scale(' + (1 - a*c.sc) + ')';
      el.style.opacity = op;
      el.style.zIndex  = Math.round(100 - a*10);
    }
  }
  function front(){ return ((Math.round(progress) % N) + N) % N; }
  function setHint(){
    hint.textContent = cards[front()].querySelector('img').getAttribute('alt');
  }
  /* A time based tween on the brand's settle curve. A spring was overshooting and
     stopping hard, so this eases out over two thirds of a second instead. */
  function ease(t){ return 1 - Math.pow(1 - t, 3); }
  function settle(t){
    if (raf){ cancelAnimationFrame(raf); raf = null; }
    target = t;
    if (reduce){ progress = t; drawDeck(); setHint(); return; }
    var from = progress, dist = t - from;
    if (Math.abs(dist) < 0.0005){ progress = t; drawDeck(); setHint(); return; }
    var dur = 520 + Math.min(320, Math.abs(dist) * 240), t0 = null;
    function frame(now){
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / dur);
      progress = from + dist * ease(k);
      drawDeck();
      if (k < 1){ raf = requestAnimationFrame(frame); }
      else { progress = target; drawDeck(); setHint(); raf = null; }
    }
    raf = requestAnimationFrame(frame);
  }
  function goTo(i){ settle(progress + wrap(i - progress)); }
  function openCard(i){
    var t = document.getElementById(cards[i].getAttribute('data-go'));
    if (t) t.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'});
  }

  /* Pointer handling with a direction lock: the deck only takes over once the
     gesture is clearly horizontal, so a vertical swipe always scrolls the page. */
  var pid = null, sx = 0, sy = 0, sProg = 0, lock = null, moved = 0, lastX = 0, lastT = 0, vx = 0;

  surf.addEventListener('pointerdown', function(e){
    if (raf){ cancelAnimationFrame(raf); raf = null; vel = 0; }
    pid = e.pointerId; sx = lastX = e.clientX; sy = e.clientY;
    sProg = progress; lock = null; moved = 0; vx = 0; lastT = e.timeStamp;
  });

  surf.addEventListener('pointermove', function(e){
    if (pid === null || e.pointerId !== pid) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (lock === null){
      if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
      if (Math.abs(dy) > Math.abs(dx)){ pid = null; return; }   /* vertical: let it scroll */
      lock = 'x';
      try { surf.setPointerCapture(pid); } catch (err) {}
      surf.classList.add('dragging');
    }
    var dt = Math.max(1, e.timeStamp - lastT);
    vx = (e.clientX - lastX) / dt * 1000;
    lastX = e.clientX; lastT = e.timeStamp;
    moved = Math.max(moved, Math.abs(dx));
    progress = sProg - dx / (cfg().sens * 1.25);
    drawDeck();
  });

  function release(e){
    if (pid === null) return;
    var c = cfg();
    var wasDrag = lock === 'x';
    try { surf.releasePointerCapture(pid); } catch (err) {}
    surf.classList.remove('dragging');
    pid = null; lock = null;

    if (!wasDrag || moved < 8){
      /* a tap: open the front card, or bring the tapped one to the front */
      var r = fan.getBoundingClientRect(), mid = r.left + r.width/2;
      var best = front(), bestD = Infinity;
      for (var i = 0; i < N; i++){
        var cx = mid + offsetOf(i) * c.x;
        var dd = Math.abs((e.clientX || mid) - cx);
        if (dd < bestD){ bestD = dd; best = i; }
      }
      if (best === front()) openCard(best); else goTo(best);
      return;
    }
    var shift = Math.round(-(e.clientX - sx) / c.dist + -vx / c.velDiv);
    shift = Math.max(-2, Math.min(2, shift));
    settle(Math.round(sProg) + shift);
  }
  surf.addEventListener('pointerup', release);
  surf.addEventListener('pointercancel', function(){
    if (pid !== null){ surf.classList.remove('dragging'); pid = null; lock = null; settle(Math.round(progress)); }
  });

  surf.addEventListener('keydown', function(e){
    if (e.key === 'ArrowRight'){ e.preventDefault(); settle(Math.round(progress) + 1); }
    else if (e.key === 'ArrowLeft'){ e.preventDefault(); settle(Math.round(progress) - 1); }
    else if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openCard(front()); }
  });

  addEventListener('resize', drawDeck, {passive:true});
  drawDeck(); setHint();

  /* ---------- the rail: seals fill as you pass them, one lava point at now ---------- */
  var railLinks = Array.prototype.slice.call(document.querySelectorAll('.rail a[data-s]'));
  var stem = document.getElementById('stem-fill');
  var secs = railLinks.map(function(a){ return document.getElementById(a.getAttribute('data-s')); });
  var tick = false;
  function railUpdate(){
    var mid = window.scrollY + window.innerHeight * 0.34;
    var cur = 0;
    secs.forEach(function(s, i){ if (s && s.offsetTop <= mid) cur = i; });
    railLinks.forEach(function(a, i){
      a.classList.toggle('done', i < cur);
      a.classList.toggle('on', i === cur);
    });
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
    stem.style.transform = 'scaleY(' + p + ')';
    /* the rail exists from the first question down to the contact block,
       never over the header or the cards. Viewport relative. */
    var railEl = document.getElementById('rail');
    var firstQ = document.getElementById('cost');
    var moreEl = document.getElementById('more');
    var railOn = !!firstQ && firstQ.getBoundingClientRect().top < window.innerHeight * 0.5;
    if (moreEl && moreEl.getBoundingClientRect().top < window.innerHeight * 0.6) railOn = false;
    railEl.classList.toggle('show', railOn);
    tick = false;
  }
  addEventListener('scroll', function(){ if(!tick){ tick = true; requestAnimationFrame(railUpdate); } }, {passive:true});
  addEventListener('resize', railUpdate, {passive:true});
  railUpdate();

})();
`;
